import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ModernWindowSolutions from "./sections/ModernWindowSolutions";
import SpaceOpportunities from "./sections/SpaceOpportunities";
import SanctuariesOfPeace from "./sections/SanctuariesOfPeace";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ModernWindowSolutions />
      <SpaceOpportunities />
      <SanctuariesOfPeace />
      <ClientSuccessStories />
      <Footer />
    </div>;
}